export const trackingStatuses = [
  "Picked Up",
  "Delayed",
  "Arrived at Facility",
  "Departed From Facility",
  "Delivered",
  "Returned",
];
